import { StatCard, StatCardGrid } from '../../../components/common';
import { fmtCurrency } from '../../../utils/formatNumber';
import { formatDate } from '../../../utils/dateUtils';
import styles from '../Reports.module.css';

export default function CashBookReport({ data }) {
  if (!data) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <StatCardGrid cols={2}>
        <StatCard label="Opening Balance" value={fmtCurrency(data.openingBalance)} />
        <StatCard label="Closing Balance" value={fmtCurrency(data.closingBalance)} valueColor="green" />
      </StatCardGrid>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Voucher No</th>
                <th>Payee / Member</th>
                <th>Narration</th>
                <th className={styles.amtRight}>Dr (₹)</th>
                <th className={styles.amtRight}>Cr (₹)</th>
                <th className={styles.amtRight}>Balance (₹)</th>
              </tr>
            </thead>
            <tbody>
              {(!data.rows || data.rows.length === 0) && (
                <tr><td colSpan={7} className="empty-state">No cash transactions in period.</td></tr>
              )}
              {data.rows?.map((r, i) => (
                <tr key={i}>
                  <td>{formatDate(r.date)}</td>
                  <td><code>{r.voucherNo}</code></td>
                  <td>{r.payeeName || '—'}</td>
                  <td>{r.narration}</td>
                  <td className={styles.amtRight}>{r.debit  ? fmtCurrency(r.debit)  : '—'}</td>
                  <td className={styles.amtRight}>{r.credit ? fmtCurrency(r.credit) : '—'}</td>
                  <td className={styles.amtRight}><strong>{fmtCurrency(r.balance)}</strong></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
